import { render } from "./Message.vue?vue&type=template&id=372b0310&scoped=true"
import script from "./Message.vue?vue&type=script&lang=ts"
export * from "./Message.vue?vue&type=script&lang=ts"

import "./Message.vue?vue&type=style&index=0&id=372b0310&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-372b0310"

export default script